<template>
  <menu-dropdown
      class="menu-dropdown"
      :options="filteredOptions"
      @menu-dropdown:select="handleSelect"
  >
    <dots />
  </menu-dropdown>
</template>

<script setup>
import { toRefs, computed } from "vue";
import { allowDownloadDOCX } from "../../utils/helpers";
import { isTailorTargetButtonEnabled } from '../../utils/helpers';

import Dots from '../../icons/actions/dots.vue'
import MenuDropdown from '../../components/menu-dropdown.vue'

import {
    StarIcon,
    TrashIcon,
    PencilSquareIcon,
    DocumentDuplicateIcon,
    ArrowDownTrayIcon,
    SparklesIcon
} from "@heroicons/vue/24/outline"

const props = defineProps({
  isCoverLetter: {
    type: Boolean,
    default: false
  },
  isWonFormat: {
    type: Boolean,
    default: true
  },
  isPrimary: {
    type: Boolean,
    default: false
  }
})

const { isCoverLetter, isPrimary } = toRefs(props)

const emit = defineEmits([
  'preview-actions:rename',
  'preview-actions:delete',
  'preview-actions:duplicate',
  'preview-actions:set-primary'
])

const filteredOptions = computed(() => {
    return [
        { value: 'tailor', label: 'Generate for a different role', icon: SparklesIcon, visible: !isCoverLetter.value && isTailorTargetButtonEnabled() && props.isWonFormat},
        { value: 'downloadpdf', label: 'Download PDF', icon: ArrowDownTrayIcon, visible: props.isWonFormat },
        { value: 'downloaddocx', label: 'Download DOCX', icon: ArrowDownTrayIcon, visible: props.isWonFormat && allowDownloadDOCX()},
        { value: 'set-primary', label: 'Set as primary', icon: StarIcon, visible: !isCoverLetter.value && !isPrimary.value },
        { value: 'set-new-primary', label: 'Replace primary resume', icon: StarIcon, visible: !isCoverLetter.value && isPrimary.value },
        { value: 'duplicate', label: 'Duplicate', icon: DocumentDuplicateIcon, visible: props.isWonFormat },
        { value: 'rename', label: 'Rename', icon: PencilSquareIcon, visible: true },
        { value: 'delete', label: 'Delete', icon: TrashIcon, visible: true },
    ].filter(el => el.visible);
})

const handleSelect = (option) => {
  emit(`preview-actions:${option.value}`)
}
</script>
